import { formatCurrency } from "../../../../utils/format";

export default function ManualField({
  row,
  FloatingInput,
  FloatingNumber,
  CustomSelect,
  cleanNumber,
  onFieldUpdate,
}) {
  const { left, mid, right, totalrow } = row;

  return (
    <div className="calc-frm-field">
      {/* Label */}
      <div className="calc-frm-fld form-group clmn-a-width">
        <FloatingInput
          value={left.label ?? ""}
          onChange={(e) =>
            onFieldUpdate(left.camelKey, "label", e.target.value)
          }
        />
      </div>

      {/* Type */}
      <div className="calc-frm-fld form-group clmn-b-width">
        <CustomSelect
          value={mid.placeholder ?? ""}
          options={
            mid.options?.length
              ? mid.options
              : ["% Loan", "% Sale Price", "Flat Fee"]
          }
          onChange={(v) => onFieldUpdate(left.camelKey, "type", v)}
        />
      </div>

      {/* Value */}
      <div className="calc-frm-fld form-group clmn-c-width">
        <FloatingNumber
          value={right.placeholder != null ? String(right.placeholder) : ""}
          onChange={(e) => {
            const raw = cleanNumber
              ? cleanNumber(e.target.value)
              : e.target.value;
            onFieldUpdate(left.camelKey, "value", raw);
          }}
          onBlur={(e) => {
            const cleaned = cleanNumber
              ? cleanNumber(e.target.value)
              : String(e.target.value).replace(/[^0-9.]/g, "");
            if (cleaned === "") return;
            const formatted = formatCurrency(cleaned);
            onFieldUpdate(left.camelKey, "value", formatted);
          }}
        />
      </div>

      {/* Total */}
      <div className="calc-frm-fld form-group fld-txt-right clmn-d-width">
        {formatCurrency(totalrow.placeholder)}
      </div>
    </div>
  );
}
